<script setup lang="ts">
import { useTruncate } from '~/js/composables/truncate'
import { Contact } from '~/js/interfaces/locations'
import { getClasses } from '~/js/composables/classes'
import { getGlobalTranslation } from '~/js/composables/translations'

import ButtonPrimary from "~/vue/atoms/buttons/ButtonPrimary.vue";
import ButtonSecondary from "~/vue/atoms/buttons/ButtonSecondary.vue";
import ImageTeaser from '~/vue/atoms/images/ImageTeaser.vue'
import TextH2 from '~/vue/atoms/texts/TextH2.vue'
import TextH3 from '~/vue/atoms/texts/TextH3.vue'
import TextOverline from '~/vue/atoms/texts/TextOverline.vue'

interface Props {
    card: Contact,
    utilities?: string,
    theme?: string|null,
}

withDefaults(defineProps<Props>(), {
    utilities: '',
    theme: null,
})

const classes = {
    wrapper: {
        _default: 'relative',
        border: 'border border-gray-300',
        grid: 'col-span-2',
        spacing: 'p-4',
        color: 'bg-white',
        flex: 'flex flex-col gap-4',
        size: 'w-full',
    },
}

</script>

<template>
    <article
        :class="[
            getClasses(classes,'wrapper'),
            utilities
        ]"
    >

        <TextOverline>
            {{ card.country }}
        </TextOverline>

        <div class="lg:grid lg:grid-cols-5 space-y-3 lg:space-y-0 lg:gap-6">
            <ImageTeaser
                v-if="card.avatar"
                :image="card.avatar"
                :sizes="['25vw']"
                ratio="aspect-square"
                utilities="lg:col-span-2 w-full lg:w-auto overflow-hidden"
            />

            <div class="col-span-3 flex flex-col gap-4">
                <div class="space-y-2">
                    <h1>
                        <TextH2>
                            {{ card.name }}
                        </TextH2>
                    </h1>
                    <h2>
                        <TextH3>
                            {{ card.role }}
                        </TextH3>
                    </h2>
                </div>

                <div class="flex flex-col gap-2 lg:gap-4">
                    <ButtonPrimary
                        :url="card.email"
                        type="a"
                        :content="getGlobalTranslation('Contact us')"
                    />
                    <ButtonSecondary
                        type="a"
                        :url="card.phone"
                        :content="card.phone.replace('tel:', '').replace(/-/gi, ' ')"
                    />
                </div>
            </div>
        </div>
    </article>
</template>